import { render, staticRenderFns } from "./ArgTagGroup.vue?vue&type=template&id=6cfd02ac&scoped=true"
import script from "./ArgTagGroup.vue?vue&type=script&lang=js"
export * from "./ArgTagGroup.vue?vue&type=script&lang=js"
import style0 from "./ArgTagGroup.vue?vue&type=style&index=0&id=6cfd02ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd02ac",
  null
  
)

export default component.exports